import { render, staticRenderFns } from "./CompProfileEditCity.vue?vue&type=template&id=4ec405fe&scoped=true"
import script from "./CompProfileEditCity.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditCity.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec405fe",
  null
  
)

export default component.exports